<template>
  <div>
    <h1>支付页</h1>
    <p>选择支付方式：</p>
    <button>微信支付</button>
    <button>支付宝支付</button>
  </div>
</template>

<script>
export default {
  name: "PaymentPage",
};
</script>